'use client';

import { useEffect, useLayoutEffect } from 'react';

const useIsoLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

export default function useHeaderHeightVar(headerId = 'app-header', fallbackPx = 72) {
  useIsoLayoutEffect(() => {
    const el = document.getElementById(headerId);
    if (!el) {
      document.documentElement.style.setProperty('--app-header-h', `${fallbackPx}px`);

      return;
    }

    const setVar = () => {
      const h = Math.round(el.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--app-header-h', `${h}px`);
    };

    setVar();

    const ro = new ResizeObserver(setVar);
    ro.observe(el);

    window.addEventListener('resize', setVar, { passive: true });

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', setVar);
    };
  }, [headerId, fallbackPx]);
}
